export const firebaseConfig = {
    apiKey: "AIzaSyCF8J7M9eUgjLWLM6qhG8EWm_0Wc3_j4Aw",
    authDomain: "webbednotes.firebaseapp.com",
    projectId: "webbednotes",
    storageBucket: "webbednotes.appspot.com",
    messagingSenderId: "677012420711",
    appId: "1:677012420711:web:706ed40e66079d433cfcc2",
    databaseURL: "https://webbednotes-default-rtdb.firebaseio.com"
  };